// @flow
import FontAwesome from 'react-fontawesome';
import React, { Component } from 'react';
import { NavDropdown, MenuItem } from 'react-bootstrap';
import locale from '../../../../../locales/index';
import api from '../../../../../services/api';

class Account extends Component<Object, {
 account: string,
}> {
  constructor(props: Object) {
    super(props);

    this.state = {
      account: api.getCurrentUser().mail,
    };
  }

  logout() {
    api.logout();
    this.setState({ account: '' });
  }

  render() {
    if (!this.state.account || this.state.account === '') {
      return <span />;
    }
    const title = (<span><FontAwesome name="user" /> {this.state.account}</span>);

    return (
      <NavDropdown eventKey={3} title={title} id="language-Select-dropdown">
        <MenuItem
          eventKey={3.1}
          onClick={() => this.logout()}
        > <FontAwesome name="sign-out" /> {locale.logout}</MenuItem>
      </NavDropdown>
    );
  }
}

export default Account;




// WEBPACK FOOTER //
// ./src/scenes/components/Header/components/Account/Account.js